export default "__VITE_ASSET__KKQe44P7__"